/* Rose Candy · Renk Kitabı 2026 — page compositions.
   Every page is composed on a 210 × 210 mm square (CSS mm = print units); anything that reaches the trim runs 3 mm past it.
   Texts come only from RC.content[lang]; product facts only from RC.products. Nothing language-specific lives here.
   Odd pages are right-hand pages (spine on their left), even pages left-hand pages (spine on their right). */
window.RC = window.RC || {};
(function () {
  RC.VERSION = '2026-10-28.1';
  let T; // active language pack

  /* where every product is presented — the index, the TOC, the menus and every cross-reference read this.
     2026-10-20 review: the setting powder left the Zemin chapter (p25) for p52, right before the setting spray (p53), because
     blush and highlighter go on before it («sabitleyici pudranın üzerine allık ve aydınlatıcı sürülmez»); the texture atlas went. */
  const PAGE = {
    micellar: 10, foam: 11, 'caps-aa': 15, 'caps-e': 15, 'caps-c': 15, 'caps-ret': 15, spf: 17, primer: 21, fdn: 22, conc: 23,
    sponge: 25, puff: 25, powder: 52, lb: 28, cb: 31, tint: 32, hl: 34, bronzer: 35, palette: 39, brow: 41, browset: 41,
    gl: 44, ml: 47, el: 49, spray: 53, bag: 55
  };
  const CH_PAGE = { 1: 8, 2: 12, 3: 18, 4: 26, 5: 36, 6: 42, 7: 50 };
  RC.PAGE = PAGE; RC.CH_PAGE = CH_PAGE;
  const FAMILY_TEX = { gl: 'gloss', ml: 'matte', el: 'matte', lb: 'drop', cb: 'cream', tint: 'tint', hl: 'shimmer', fdn: 'foundation', conc: 'foundation', powder: 'powder', brow: 'brow' };

  /* ---------- helpers ---------- */
  const base = () => RC.imgBase || 'assets/img/lo';
  /* a picture's address: on the store the viewer maps the book path to Shopify Files (RC.imgURL), elsewhere the local folder */
  const picture = (path) => (RC.imgURL ? RC.imgURL(path) : `${base()}/${path}`);
  const concept = (n) => picture(`concept/${n}.jpg`);
  const packSrc = (k) => picture(`products/${k}.jpg`);
  const brand = (f) => picture(`brand/${f}`);
  const swSrc = (tex, key) => picture(`swatch/${tex}--${key}.${RC.imgExt === 'png' ? 'png' : 'webp'}`);
  const P = (k) => RC.products[k];
  const pn = (k) => T.p[k].name;
  const pref = (n, cls = '') => `<span class="pref ${cls}">${T.meta.pageWord}&nbsp;${n}</span>`;
  const eyebrow = (txt, cls = '') => `<p class="eyebrow ${cls}">${RC.rose('rose')}<span>${txt}</span></p>`;
  const title = (t, cls = '', style = '') => `<h2 class="title ${cls}" style="${style}">${t[0]}${t[1] ? `<br><i>${t[1]}</i>` : ''}</h2>`;
  const at = (x, y, w, inner, cls = '', extra = '') => `<div class="abs ${cls}" style="left:${x}mm;top:${y}mm;${w ? `width:${w}mm;` : ''}${extra}">${inner}</div>`;
  const steps = (list, cls = '') => `<ol class="steps ${cls}">${list.map((s) => `<li><p>${s}</p></li>`).join('')}</ol>`;
  /* selected ingredients: printed for the skincare (micellar water, the capsule serums) and the bronzer oil only; colour make-up
     carries none since the 2026-10-20 review («renkli ürünlerde bileşenleri belirtmemiz gerekmiyor») */
  const keys = (list, cls = '', label = true) => `${label ? `<p class="keys-label">${T.meta.keys}</p>` : ''}<div class="keys ${cls}">${list.map((k) => `<span>${k}</span>`).join('')}</div>`;
  const warn = (txt) => `<p class="warn">${txt}</p>`;
  /* net contents are kept as printed on the Turkish label ('20 × 0,5 ml', '12 × 2,6 g = 31,2 g'); a language swaps the unit words and the decimal comma */
  const sizeOf = (k) => Object.entries(T.meta.units || {}).reduce((v, [w, t]) => v.replace(w, t), P(k).size).replace(/(\d),(\d)/g, `$1${T.meta.decimal || ','}$2`);
  const metaOne = (k, light = false) => `<p class="meta ${light ? 'light' : ''}"><b>${T.meta.sku}</b> ${P(k).sku} · <b>${T.meta.barcode}</b> ${P(k).barcode}${sizeOf(k) ? ` · ${sizeOf(k)}` : ''}</p>`;
  const sw = (key) => swSrc(FAMILY_TEX[key.split('-')[0]], key);
  const shadeObj = (k, name) => P(k).shades.find((s) => s.name === name);
  /* shade names stand alone: the Turkish notes under them (T.shades) are not printed since the 2026-10-20 review */
  const img = (src, style, cls = '', alt = '') => `<img class="${cls}" src="${src}" style="${style}" alt="${alt}" decoding="async">`;
  const fullImg = (name, pos = '50% 50%', zoom = 1) => `<div class="full-img"><img src="${concept(name)}" style="object-position:${pos}${zoom !== 1 ? `;transform:scale(${zoom});transform-origin:${pos}` : ''}" alt="" decoding="async"></div>`;
  const spreadImg = (name, side, pos = '50% 50%') => `<div class="sp-img ${side}"><img src="${concept(name)}" style="object-position:${pos}" alt="" decoding="async"></div>`;
  /* a photograph cropped to [x0, y0, x1, y1] (px of its source, size [sw, sh]) and set into a w × h mm box, with numbered pins at source px */
  const cropFrame = (name, x, y, w, h, [sw, sh], [x0, y0, x1], pins, cls = 'soft') => {
    const s = w / (x1 - x0);
    return `<div class="frame ${cls}" style="left:${x}mm;top:${y}mm;width:${w}mm;height:${h}mm"><img src="${concept(name)}" style="left:${(-x0 * s).toFixed(2)}mm;top:${(-y0 * s).toFixed(2)}mm;width:${(sw * s).toFixed(2)}mm;height:${(sh * s).toFixed(2)}mm;object-fit:fill" alt=""></div>`
      + pins.map(([px, py], i) => `<span class="pin" style="left:${(x + (px - x0) * s).toFixed(1)}mm;top:${(y + (py - y0) * s).toFixed(1)}mm">${i + 1}</span>`).join('');
  };
  /* a point of a full-bleed picture (n px wide), in page mm: the picture covers the 216 mm bleed box */
  const onBleed = (v, n = 1024) => (-3 + v * 216 / n).toFixed(1);
  const frame = (name, x, y, w, h, cls = 'soft', pos = '50% 50%') => `<div class="frame ${cls}" style="left:${x}mm;top:${y}mm;width:${w}mm;height:${h}mm"><img src="${concept(name)}" style="object-position:${pos}" alt="" decoding="async"></div>`;
  const pname = (k, cls = '') => `<h3 class="p-name ${cls}">${pn(k)}</h3>`;
  const ptype = (k) => `<p class="p-type">${T.p[k].type || ''}</p>`;
  const lead = (k, cls = '') => `<p class="note ${cls}" style="margin:1.4mm 0 2.4mm">${T.p[k].lead}</p>`;
  const body = (k, cls = '') => `<p class="body ${cls}">${T.p[k].body}</p>`;
  const howTo = (cls = '') => `<p class="keys-label ${cls}" style="margin:3.2mm 0 1.8mm">${T.meta.howTo}</p>`;
  const folio = (n, opts = {}) => {
    const side = n % 2 ? 'r' : 'l';
    const ch = opts.ch ? `${T.meta.layer} ${T.chapters[opts.ch].no} · ${T.chapters[opts.ch].name}` : (opts.label || T.meta.running);
    return `<p class="folio ${side} ${opts.light ? 'light' : ''}"><span class="n">${n}</span><span>${ch}</span>${RC.rose('', 'currentColor')}</p>`;
  };
  /* a shade row: real swatch, name, code */
  const shadeRow = (k, s, opts = {}) => `<div class="shade-row" style="${opts.style || ''}">
      <img src="${sw(s.key)}" style="width:${opts.w || 16}mm;height:${opts.h || 8}mm;object-fit:contain;flex:none" alt="">
      <div><p class="shade-name">${s.name}</p><p class="shade-code">${s.sku} · ${s.barcode}</p></div></div>`;
  /* chapter opener: a blush page — the layer's number in huge white capitals, its name in rose, what it holds, the rose so far */
  const chapterPage = (ch, items) => {
    const c = T.chapters[ch];
    return `
      ${at(16, 16, 120, eyebrow(T.meta.layer))}
      <p class="ch-num" style="left:14.4mm;top:25mm">${c.no}</p>
      ${at(16, 100, 170, `<h2 class="title xl">${c.name}.</h2><p class="lead" style="margin-top:3mm;color:var(--ink)">${c.line}</p>`)}
      ${at(16, 136, 118, `<div class="ch-list">${items.map(([k, n]) => `<span><span>${k}</span><span>${n}</span></span>`).join('')}</div>`)}
      <div class="progress" style="left:16mm;top:176mm">${RC.progress(ch, 7, 18, 'var(--rose)', 'rgba(169,95,120,.22)')}</div>`;
  };
  /* the opener photograph cropped to the page that faces the type: [image, object-position, zoom]; Bakım's backdrop has a paper
     seam 10% in from the page edge, so that page is cut a little tighter */
  const CH_PHOTO = { 1: ['ch-temiz', '50% 50%'], 2: ['ch-bakim', '100% 50%', 1.14], 3: ['ch-zemin', '50% 50%'], 4: ['ch-yanak', '50% 50%'],
    5: ['ch-bakis', '50% 50%'], 6: ['ch-dudak-damla', '50% 50%'], 7: ['ch-son', '50% 50%'] };   // the model openers are square since 10-19
  const chapterPhoto = (ch) => fullImg(...CH_PHOTO[ch]);

  /* ---------- pages ---------- */
  const PG = [];
  const page = (n, opt, render) => PG.push({ n, ...opt, render });

  /* 1 — COVER: one campaign photograph, the white logo as a masthead, the book's name at the foot */
  const COVER = { img: 'kapak', pos: '50% 50%' };             // agy scene «p-kapak» (10-20, review R15: no woman): the layered cake on its stand, right of centre
  page(1, { cls: 'pg-cover' }, () => `
    ${fullImg(COVER.img, COVER.pos)}
    <img class="cover-logo" src="${brand('logo-white-t.svg')}" style="left:13mm;top:13mm;width:62mm;transform:none" alt="Rose Candy">
    <p class="cover-name">${T.cover.kicker[0]}</p>
    <p class="cover-meta"><span>${T.cover.kicker[1]}</span><span>${T.cover.sub}</span></p>`);

  /* 2 — ENDPAPER: the slogan in rose capitals on blush */
  page(2, { cls: 'bg-blush2' }, () => `
    <div class="abs" style="left:20mm;top:84mm;width:170mm;text-align:center">
      ${RC.rose('', 'var(--rose)', 'width:9mm;height:9mm;display:block;margin:0 auto 6mm')}
      <p class="title l">${T.endpaper.slogan}</p>
      <p class="eyebrow" style="justify-content:center;margin-top:6mm">${T.endpaper.url}</p></div>`);

  /* 3 — WELCOME */
  page(3, {}, () => `
    ${at(18, 16, 120, eyebrow(T.hello.eyebrow))}
    ${at(18, 24, 130, title(T.hello.title, 'l'))}
    ${at(18, 74, 104, T.hello.body.map((p) => `<p class="body" style="font-size:8.8pt">${p}</p>`).join(''))}
    ${at(146, 74, 50, T.hello.facts.map(([n, l]) => `<div style="border-top:.3mm solid var(--line-strong);padding:3mm 0 4mm"><p style="font:800 36pt/.86 var(--f-narrow);color:var(--rose)">${n}</p><p class="small" style="margin-top:1.5mm">${l}</p></div>`).join(''))}
    ${at(18, 152, 70, `<p class="note" style="font-size:11pt;color:var(--ink)">${T.hello.sign}</p>`)}
    <img class="abs" src="${brand('logo-t.svg')}" style="left:18mm;top:162mm;width:42mm" alt="Rose Candy">
    <img class="swatch" src="${swSrc('kiss', 'gl-pink-donut')}" style="left:78mm;top:146mm;width:38mm;transform:rotate(-12deg);mix-blend-mode:multiply;opacity:.95" alt="">
    ${folio(3)}`);

  /* 4–5 — CONTENTS: the list of the seven layers, then the layers as a picture row in reading order */
  page(4, {}, () => `
    ${at(14, 16, 120, eyebrow(T.toc.eyebrow))}
    ${at(14, 24, 170, title(T.toc.title, 'l'))}
    ${at(14, 66, 120, `<p class="body" style="font-size:8.8pt">${T.toc.intro}</p>`)}
    ${at(14, 86, 176, Object.keys(T.chapters).map((ch) => {
      const c = T.chapters[ch];
      return `<span style="display:grid;grid-template-columns:15mm 1fr auto;align-items:baseline;border-top:.25mm solid var(--line-strong);padding:1.6mm 0 1.7mm">
        <span style="font:300 15pt/1 var(--f-wide);color:var(--berry)">${c.no}</span>
        <span><b style="font:600 11pt/1.1 var(--f-display);letter-spacing:-.015em">${c.name}</b><span class="small" style="margin-left:2.5mm">${c.short}</span></span>
        <span style="font:700 7pt/1 var(--f-text);color:var(--berry)">${CH_PAGE[ch]}</span></span>`;
    }).join(''))}
    ${at(14, 162, 120, `<p class="keys-label">${T.toc.shortcutsTitle}</p>` + T.toc.shortcuts.slice(0, 3).map(([l, n]) => `<span class="shortcut"><span>${l}</span><i></i><b>${n}</b></span>`).join(''))}
    ${at(140, 162, 56, `<p class="keys-label">&nbsp;</p>` + T.toc.shortcuts.slice(3).map(([l, n]) => `<span class="shortcut"><span>${l}</span><i></i><b>${n}</b></span>`).join(''))}
    ${folio(4)}`);

  /* each stop shows the detail that names its layer: [opener image, focus x, focus y (0–1), zoom] */
  const TOC_THUMB = { 1: ['ch-temiz', .52, .45, 1.6], 2: ['ch-bakim', .80, .38, 2.0], 3: ['ch-zemin', .52, .45, 1.6], 4: ['ch-yanak', .55, .45, 1.5],
    5: ['ch-bakis', .52, .36, 1.6], 6: ['ch-dudak-damla', .5, .5, 2.2], 7: ['ch-son', .50, .45, 1.5] };   // 7: 10-20, the face and the closed spray
  const ASPECT = { 'ch-bakim': 5504 / 3072 };   // every other opener is square
  const thumbBg = ([img, u, v, z], d) => {
    const H = z * d, W = H * (ASPECT[img] || 1);
    const px = Math.min(1, Math.max(0, (u * W - d / 2) / (W - d))) * 100, py = Math.min(1, Math.max(0, (v * H - d / 2) / (H - d))) * 100;
    return `background-image:url(${concept(img)});background-size:auto ${z * 100}%;background-position:${px.toFixed(1)}% ${py.toFixed(1)}%`;
  };
  /* 5 — the seven layers in the order they are applied (2026-10-20 review: «rutine göre 1-2-3… sırasında»; the spiral read as a
     shuffle): 01–04 left to right, 05–07 below, a thin line through the circles from 01 to 07 that turns at the right edge and
     runs back above the second row; the photographs grow a little from the first row to the second.
     [centre x, centre y, diameter] in mm */
  const TOC_AT = [[33, 52, 38], [78, 52, 38], [123, 52, 38], [168, 52, 38], [50, 136, 46], [105, 136, 46], [160, 136, 46]];
  const TOC_LINE = 'M33 52 H186 Q196 52 196 62 V94 Q196 104 186 104 H60 Q50 104 50 114 V136 H160';
  page(5, { cls: 'bg-blush' }, () => `
      <svg class="abs" style="left:0;top:0;width:210mm;height:210mm" viewBox="0 0 210 210" aria-hidden="true">
        <path d="${TOC_LINE}" fill="none" stroke="var(--rose)" stroke-width=".3" stroke-linecap="round" stroke-linejoin="round"/></svg>
      ${TOC_AT.map(([x, y, d], i) => {
        const ch = i + 1; const c = T.chapters[ch];
        return `<span class="toc-stop">
          <span class="toc-thumb" style="left:${x - d / 2}mm;top:${y - d / 2}mm;width:${d}mm;height:${d}mm;${thumbBg(TOC_THUMB[ch], d)}"></span>
          <span class="toc-lbl" style="left:${x}mm;top:${y + d / 2 + 2.8}mm;transform:translateX(-50%);text-align:center"><span class="toc-no">${c.no}</span><span class="toc-name">${c.name}</span><span class="toc-sub">${c.short}<br><b>${T.meta.pageWord} ${CH_PAGE[ch]}</b></span></span></span>`;
      }).join('')}
      ${folio(5)}`);

  /* 6–7 — SHADE WALL: every colour as its own texture on white, named like a pastry counter */
  const wallRow = (fam, y) => `
    ${at(16, y + 1, 34, `<p class="keys-label" style="margin:0">${T.menu.groups[fam]}</p><span class="pref" style="display:inline-block;margin-top:1.8mm">${T.meta.pageWord} ${PAGE[fam]}</span>`)}
    ${P(fam).shades.map((s, i) => at(52 + i * 29, y, 27, `<span style="display:block">
      <img src="${sw(s.key)}" style="width:27mm;height:12mm;object-fit:contain;object-position:left center" alt="">
      <p class="shade-name" style="font-size:7.6pt;margin-top:1.6mm">${s.name}</p></span>`)).join('')}`;
  page(6, { cls: 'bg-white' }, () => `
    ${at(16, 16, 120, eyebrow(T.menu.eyebrow))}
    ${at(16, 24, 178, title(T.menu.title, 'l'))}
    ${at(16, 62, 120, `<p class="body" style="font-size:8.4pt">${T.menu.intro}</p>`)}
    ${['gl', 'ml', 'el', 'tint'].map((f, i) => wallRow(f, 84 + i * 26)).join('')}
    ${folio(6)}`);
  page(7, { cls: 'bg-white' }, () => `
    ${['lb', 'cb', 'hl', 'fdn', 'conc', 'powder', 'brow'].map((f, i) => wallRow(f, 16 + i * 25.5)).join('')}
    ${folio(7)}`);

  /* ===== 01 · TEMİZ ===== */
  page(8, { cls: 'bg-blush2' }, () => chapterPage(1, [[pn('micellar'), PAGE.micellar], [pn('foam'), PAGE.foam]]));
  page(9, {}, () => chapterPhoto(1));

  page(10, {}, () => `
    ${fullImg('sc-micellar', '50% 50%')}
    ${at(14, 16, 88, `${ptype('micellar')}${pname('micellar')}${lead('micellar')}${body('micellar')}`, 'card glass', 'padding:4.5mm 5mm')}
    ${at(14, 112, 80, `${keys(T.p.micellar.keys)}<div style="margin-top:3mm">${metaOne('micellar')}</div><div style="margin-top:2mm">${warn(T.p.micellar.warn)}</div>`, 'card glass', 'padding:4mm 4.5mm')}
    `);

  /* 11 — the foam scene cut close, so the bottle and its foam fill the pill */
  page(11, {}, () => `
    ${cropFrame('sc-foam', 112, 10, 84, 126, [3712, 4608], [541, 450, 3091], [], 'pill')}
    ${at(18, 16, 90, `${ptype('foam')}${pname('foam')}${lead('foam')}${body('foam')}<div style="margin-top:3mm">${metaOne('foam')}</div><p class="note" style="margin-top:9mm;padding-top:3mm;border-top:.25mm solid var(--line-strong)">${T.temiz.twoWays.note}</p>`)}
    ${at(18, 142, 178, `<div style="display:grid;grid-template-columns:1fr 1fr;gap:8mm">
      <div><p class="p-name s">${T.temiz.twoWays.a[0]}</p><p class="small" style="margin:.8mm 0 2.4mm">${T.temiz.twoWays.a[1]} · ${pref(PAGE.micellar)}</p>${steps(T.p.micellar.steps)}</div>
      <div><p class="p-name s">${T.temiz.twoWays.b[0]}</p><p class="small" style="margin:.8mm 0 2.4mm">${T.temiz.twoWays.b[1]}</p>${steps(T.p.foam.steps)}</div></div>`)}
    ${folio(11, { ch: 1 })}`);

  /* ===== 02 · BAKIM ===== */
  page(12, { cls: 'bg-blush2' }, () => chapterPage(2, [[T.p['caps-c'].name.replace('C Vitamini ', ''), PAGE['caps-c']], [T.p.spf.short, PAGE.spf]]));
  page(13, {}, () => chapterPhoto(2));

  const OIL_PINS = [[.255, .27], [.48, .76], [.63, .62], [.40, .22], [.68, .30], [.33, .78]]; // avocado, jojoba, lavender, nuts, citrus, wheat
  page(14, {}, () => `
    <div class="frame" style="left:-3mm;top:-3mm;width:216mm;height:122mm"><img src="${concept('ing-yaglar')}" style="object-position:50% 50%" alt=""></div>
    ${OIL_PINS.map(([fx, fy], i) => `<span class="abs" style="left:${fx * 216 - 3 - 3}mm;top:${fy * 122 - 3 - 3}mm;width:6mm;height:6mm;border-radius:50%;background:var(--white);color:var(--berry);font:600 7pt/6mm var(--f-display);text-align:center">${i + 1}</span>`).join('')}
    ${at(14, 126, 80, `${title(T.kapsul.oilsTitle, 'm')}<p class="body" style="margin-top:3mm">${T.kapsul.oilsIntro}</p>`)}
    ${at(104, 128, 90, T.kapsul.oils.map(([n, ks], i) => `<div style="display:grid;grid-template-columns:7mm 1fr;align-items:baseline;border-bottom:.25mm solid var(--line);padding:1.3mm 0">
      <span style="font:300 11pt/1 var(--f-wide);color:var(--berry)">${i + 1}</span>
      <span><b style="font:600 8.4pt/1.2 var(--f-display)">${n}</b><span class="small" style="display:block">${ks.split(' ').map((k) => T.p[k].short).join(' · ')}</span></span></div>`).join(''))}
    ${folio(14, { ch: 2 })}`);

  page(15, {}, () => {
    /* each card: name, area and contents only (2026-10-20 review: label and capsule colours confused readers) */
    const caps = ['caps-aa', 'caps-e', 'caps-c', 'caps-ret'];
    return `
    <div class="frame" style="left:-3mm;top:-3mm;width:216mm;height:92mm"><img src="${concept('sc-kapsul')}" style="object-position:50% 58%" alt=""></div>
    ${at(18, 96, 120, title(T.kapsul.cmpTitle, 'm'))}
    ${at(18, 117, 178, `<p class="body">${T.kapsul.cmpIntro}</p>`)}
    ${caps.map((k, i) => at(18 + i * 45, 132, 41, `
      <p class="p-name xs" style="min-height:8mm">${T.p[k].name}</p>
      <p class="small" style="margin-top:1.4mm"><b>${T.kapsul.rows.area}:</b> ${T.p[k].area}</p>
      <p class="tiny" style="margin-top:1.6mm;color:var(--ink-2)">${T.p[k].keys.join(' · ')}</p>
      <p class="meta" style="margin-top:2mm">${P(k).sku} · ${P(k).barcode}<br>${sizeOf(k)}</p>`, '', 'border-top:.5mm solid var(--ink);padding-top:2mm')).join('')}
    ${at(18, 190, 176, `<p class="tiny">${T.meta.keysNote}</p>`)}
    ${folio(15, { ch: 2 })}`;
  });

  page(16, {}, () => `
    ${fullImg('sc-kapsul-el')}
    ${at(14, 16, 54, `${title(T.kapsul.ritualTitle, 'l', 'font-size:42pt')}<div style="margin-top:6mm">${steps(T.kapsul.ritual)}</div><p class="tiny" style="margin-top:4mm;color:var(--ink-2)">${T.kapsul.ritualNote}</p>`)}
    `);

  page(17, {}, () => `
    <div class="frame" style="left:-3mm;top:-3mm;width:216mm;height:112mm"><img src="${concept('sc-spf')}" style="object-position:50% 40%" alt=""></div>
    ${at(18, 116, 84, `${title(T.gunes.title, 'm')}<p class="p-type" style="margin-top:4mm">${T.p.spf.type}</p><p class="p-name s">${pn('spf')}</p><p class="body" style="margin-top:2.4mm">${T.p.spf.body}</p><div style="margin-top:3mm">${metaOne('spf')}</div>`)}
    ${at(112, 118, 84, `${howTo()}${steps(T.p.spf.steps)}<p class="keys-label" style="margin:3.4mm 0 1.6mm">${T.gunes.renew}</p><div class="keys on-white">${T.gunes.renewList.map((r) => `<span>${r}</span>`).join('')}</div><div style="margin-top:3.4mm">${warn(T.p.spf.warn)}</div>`)}
    ${folio(17, { ch: 2 })}`);

  /* ===== 03 · ZEMİN ===== */
  page(18, { cls: 'bg-blush2' }, () => chapterPage(3, [[pn('primer'), PAGE.primer], [pn('fdn'), PAGE.fdn], [pn('conc'), PAGE.conc], [`${pn('sponge')} · ${pn('puff')}`, PAGE.sponge]]));
  page(19, {}, () => chapterPhoto(3));

  /* 20 — the base layers as a cake: the photograph is the cake, the labels are type. Layer middles measured on pasta.png.
     2026-10-20: blush and highlighter (label 6) now come before the setting powder (label 7), and the two bands were swapped
     in pasta.png the same day (the rose mousse 7th from the bottom, the powdered band 8th, each at the other's old height),
     so the measured heights stand. A label whose note runs to two lines gets a taller row. */
  const CAKE_Y = [167.6, 155.2, 144.0, 135.8, 124.2, 110.5, 99.7, 88.1, 81.6];   // bottom → top, mm on the page
  page(20, {}, () => {
    const L = T.cake.layers, edge = 120, lx = 132;
    const rowH = (i) => (L[i][1].length > 45 ? 14 : 10.5);                    // a note longer than ~45 characters wraps in 64 mm
    /* from 66 mm (clear of the two-line English title and intro) down to 157 mm (the last note stays above the plate's rim) */
    const rowY = (i) => { let y = 66; for (let j = L.length - 1; j > i; j--) y += rowH(j); return y; };
    const leaders = L.map((_, i) => {
      const y = CAKE_Y[i], ty = rowY(i) + 2.6;
      return `<path d="M${edge} ${y} L${edge + 4} ${y} C${edge + 8} ${y} ${lx - 6} ${ty} ${lx - 1.6} ${ty}" fill="none" stroke="var(--ink)" stroke-width=".22"/><circle cx="${edge}" cy="${y}" r=".75" fill="var(--ink)"/>`;
    }).join('');
    const labels = L.map(([nm, sub, k], i) => {
      const pg = k === 'caps' ? PAGE['caps-c'] : PAGE[k];
      return at(lx, rowY(i), 64, `<span style="display:block"><span style="font:600 8.8pt/1.1 var(--f-display);letter-spacing:-.01em">${nm}</span> <span class="pref" style="margin-left:1.2mm">${T.meta.pageWord} ${pg}</span><br><span class="small">${sub}</span></span>`);
    }).join('');
    return `
      ${fullImg('pasta', '50% 50%')}
      ${at(lx, 16, 66, `${eyebrow(T.cake.eyebrow)}${title(T.cake.title, 'm', 'margin-top:2.6mm')}<p class="body" style="font-size:8pt;margin-top:3.2mm;max-width:62mm">${T.cake.intro}</p>`)}
      <svg class="abs" style="left:0;top:0;width:210mm;height:210mm" viewBox="0 0 210 210" aria-hidden="true">${leaders}
        <path d="M51 70.4 L55.2 70.4" stroke="var(--ink)" stroke-width=".22"/><circle cx="55.2" cy="70.4" r=".75" fill="var(--ink)"/></svg>
      ${labels}
      ${at(12, 64.5, 38, `<span style="display:block;text-align:right"><span class="note" style="color:var(--ink)">${T.cake.cherry[0]}</span><br><b style="font:600 8.8pt/1.3 var(--f-display)">${T.cake.cherry[1]}</b> <span class="pref">${T.meta.pageWord} ${T.cake.cherryPage}</span></span>`)}
      ${folio(20, { ch: 3 })}`;
  });

  page(21, {}, () => `
    ${frame('sc-primer', 112, 14, 84, 162, 'arch', '50% 50%')}
    ${at(18, 16, 86, `${ptype('primer')}${pname('primer')}${lead('primer')}${body('primer')}${howTo()}${steps(T.p.primer.steps)}
      <p class="keys-label" style="margin-top:7mm">${T.ten.next}</p><p class="small">${pn('fdn')} ${pref(PAGE.fdn)}<br>${pn('conc')} ${pref(PAGE.conc)}</p>`)}
    ${at(18, 150, 86, metaOne('primer'))}
    ${folio(21, { ch: 3 })}`);

  page(22, {}, () => `
    <div class="frame" style="left:-3mm;top:-3mm;width:216mm;height:118mm"><img src="${concept('sc-ten')}" style="object-position:50% 60%" alt=""></div>
    ${at(14, 124, 92, `${ptype('fdn')}${pname('fdn')}${lead('fdn')}${body('fdn')}`)}
    ${at(114, 124, 82, `${howTo()}${steps(T.p.fdn.steps)}<div style="margin-top:3mm">${P('fdn').shades.map((s) => `<p class="meta">${s.name} · ${s.sku} · ${s.barcode}</p>`).join('')}<p class="meta">${sizeOf('fdn')}</p></div>`)}
    ${folio(22, { ch: 3 })}`);

  page(23, {}, () => {
    const lad = (k, x, y) => P(k).shades.map((s, i) => `<div class="abs" style="left:${x + i * 7}mm;top:${y + i * 15}mm;width:${78 - i * 7}mm;display:flex;align-items:center;gap:2.6mm">
        <img src="${sw(s.key)}" style="width:40mm;height:13mm;object-fit:contain;flex:none" alt="">
        <div><p class="shade-name">${s.name}</p><p class="shade-code">${s.sku}</p></div></div>`).join('');
    return `
    ${at(18, 16, 170, title(T.ten.guideTitle, 'l'))}
    ${at(18, 56, 84, `<p class="body">${T.ten.guideIntro}</p>`)}
    <p class="abs keys-label" style="left:18mm;top:78mm">${pn('fdn')}</p>
    ${lad('fdn', 18, 84)}
    <p class="abs keys-label" style="left:112mm;top:78mm">${pn('conc')}</p>
    ${lad('conc', 112, 84)}
    ${at(18, 140, 82, `${ptype('conc')}${pname('conc', 's')}${lead('conc')}${body('conc')}`)}
    ${at(112, 140, 84, `${howTo()}${steps(T.p.conc.steps)}`)}
    ${at(18, 189, 178, `<p class="tiny" style="color:var(--berry)">${T.ten.sameName}</p>`)}
    ${folio(23, { ch: 3 })}`;
  });

  page(24, {}, () => `${fullImg('sc-araclar', '50% 50%')}`);

  /* 25 — the two sponges, each with its own packshot beside its text (2026-10-20 review: «hangi sünger ne için belli olsun»);
     the setting powder moved to p52 */
  page(25, {}, () => `
    ${at(18, 16, 104, title(T.araclar.title, 'l'))}
    ${at(18, 56, 92, `<p class="body">${T.araclar.intro}</p>`)}
    ${at(18, 80, 92, `${ptype('sponge')}${pname('sponge', 's')}${lead('sponge')}${body('sponge')}${steps(T.p.sponge.steps)}<div style="margin-top:2.6mm">${metaOne('sponge')}</div>`)}
    <img class="pack" src="${packSrc('sponge')}" style="left:122mm;top:76mm;width:70mm" alt="">
    ${at(18, 152, 92, `${ptype('puff')}${pname('puff', 's')}<p class="body" style="margin-top:1.4mm">${T.p.puff.body}</p><div style="margin-top:2mm">${metaOne('puff')}</div>`)}
    <img class="pack" src="${packSrc('puff')}" style="left:136mm;top:138mm;width:40mm" alt="">
    ${folio(25, { ch: 3 })}`);

  /* ===== 04 · YANAK ===== */
  page(26, { cls: 'bg-blush2' }, () => chapterPage(4, [[pn('lb'), PAGE.lb], [pn('cb'), PAGE.cb], [pn('tint'), PAGE.tint], [pn('hl'), PAGE.hl], [pn('bronzer'), PAGE.bronzer]]));
  page(27, {}, () => chapterPhoto(4));

  page(28, {}, () => {
    const sh = P('lb').shades;
    const pos = [[22, 78], [56, 102], [92, 78], [128, 102], [162, 78]];
    return `
    ${at(14, 16, 104, `${ptype('lb')}${pname('lb')}${lead('lb')}${body('lb')}`)}
    ${at(126, 18, 70, `${howTo('')}${steps(T.p.lb.steps)}`)}
    ${sh.map((s, i) => `<div class="abs" style="left:${pos[i][0] - 3}mm;top:${pos[i][1]}mm;width:30mm;text-align:center">
        <img src="${sw(s.key)}" style="width:25mm;height:25mm;object-fit:contain;margin:0 auto" alt="">
        <p class="shade-name" style="margin-top:2mm">${s.name}</p><p class="shade-code">${s.sku}<br>${s.barcode}</p></div>`).join('')}
    ${at(14, 166, 120, `<p class="meta">${T.meta.size} ${sizeOf('lb')}</p>`)}
    ${folio(28, { ch: 4 })}`;
  });
  page(29, {}, () => `${fullImg('sc-likit-allik', '50% 72%')}`);

  /* where each compact sits in the photograph (mm on the page), box order: top row mocha, ruby · bottom row desert, pink bloom, coral */
  /* pins on each compact's upper-left rim; the box scene is the all-closed take with the ruby compact's hinged lid opened
     (two agy takes of one composition, merged where they differ: src/concept/_agy/sc-krem-kutu-mix.png) */
  const BOX_AT = [[54.1, 54.1], [116.9, 54.1], [24.8, 118.6], [84.2, 118.6], [143.7, 118.6]];
  page(30, {}, () => `${fullImg('sc-krem-kutu', '50% 50%')}
    ${BOX_AT.map(([x, y], i) => `<span class="pin" style="left:${x}mm;top:${y}mm">${i + 1}</span>`).join('')}`);
  page(31, {}, () => {
    const boxOrder = ['Mocha Kiss', 'Ruby Glow', 'Desert Nude', 'Pink Bloom', 'Coral Sunset'].map((n) => shadeObj('cb', n));
    return `
    ${at(18, 16, 100, `${ptype('cb')}${pname('cb')}${lead('cb')}${body('cb')}`)}
    ${at(128, 16, 68, `${howTo('')}${steps(T.p.cb.steps)}`)}
    ${at(18, 62, 178, `<p class="keys-label">${T.yanak.boxTitle}</p><p class="small" style="margin-bottom:3mm">${T.yanak.boxIntro}</p>` + boxOrder.map((s, i) => `<div style="display:grid;grid-template-columns:12mm 44mm 1fr auto;align-items:center;column-gap:3mm;border-top:.25mm solid var(--line);padding:2.2mm 0">
      <span style="font:300 20pt/1 var(--f-wide);color:var(--berry)">${i + 1}</span><img src="${sw(s.key)}" style="width:44mm;height:15mm;object-fit:contain;object-position:left center" alt="">
      <span><span class="shade-name" style="font-size:10pt">${s.name}</span></span><span class="shade-code" style="text-align:right">${s.sku}<br>${s.barcode}</span></div>`).join(''))}
    ${at(18, 176, 178, `<p class="meta">${T.meta.size} ${sizeOf('cb')}</p>`)}
    ${folio(31, { ch: 4 })}`;
  });

  page(32, {}, () => `
    ${fullImg('sc-tint')}
    ${at(14, 140, 84, `${ptype('tint')}${pname('tint', 's')}${lead('tint')}<p class="body">${T.p.tint.body}</p>`, 'card glass', 'padding:4.5mm 5mm')}
    ${at(110, 150, 86, P('tint').shades.map((s) => shadeRow('tint', s, { w: 20, h: 10, style: 'margin-bottom:1.5mm' })).join('') + `<p class="meta">${sizeOf('tint')}</p>`, 'card glass', 'padding:3.5mm 4mm')}
    `);

  page(33, {}, () => {
    const cols = T.yanak.cmpCols, rows = T.yanak.cmpRows;
    const icons = [sw('lb-candy-pop'), sw('cb-pink-bloom'), sw('tint-mango')];
    return `
    ${at(18, 16, 170, title(T.yanak.cmpTitle, 'l'))}
    ${at(18, 56, 110, `<p class="body">${T.yanak.cmpIntro}</p>`)}
    <table class="cmp" style="left:18mm;top:76mm;width:178mm"><thead><tr><th></th>${cols.map((c, i) => `<th><img src="${icons[i]}" style="width:24mm;height:12mm;object-fit:contain;margin-bottom:1.6mm" alt="">${c}</th>`).join('')}</tr></thead>
      <tbody>${rows.map((r) => `<tr><th>${r[0]}</th>${r.slice(1).map((c) => `<td>${c}</td>`).join('')}</tr>`).join('')}
      <tr><th></th>${['lb', 'cb', 'tint'].map((k) => `<td>${pref(PAGE[k])}</td>`).join('')}</tr></tbody></table>
    ${cropFrame('yuz-harita', 18, 138, 56, 56, [1024, 1024], [340, 230, 940], [[590, 500], [720, 410]])}
    ${at(84, 152, 112, `<p class="keys-label">${T.yanak.placeTitle}</p>${T.yanak.place.map((t, i) => `<p style="display:grid;grid-template-columns:7mm 1fr;align-items:baseline;margin-top:1.6mm"><span style="font:300 12pt/1 var(--f-wide);color:var(--berry)">${i + 1}</span><span class="note" style="color:var(--ink);font-size:9pt">${t}</span></p>`).join('')}`)}
    ${folio(33, { ch: 4 })}`;
  });

  page(34, {}, () => `
    <div class="frame" style="left:-3mm;top:-3mm;width:216mm;height:116mm"><img src="${concept('sc-aydinlatici')}" style="object-position:50% 42%" alt=""></div>
    ${at(14, 120, 92, `${ptype('hl')}${pname('hl')}${lead('hl')}${body('hl')}<p class="note" style="margin-top:2.6mm;font-size:7.6pt">${T.p.hl.tip}</p>
      <p class="meta" style="margin-top:5mm">${T.meta.size} ${sizeOf('hl')}</p>`)}
    ${at(114, 122, 82, P('hl').shades.map((s) => shadeRow('hl', s, { w: 24, h: 11, style: 'margin-bottom:2mm' })).join(''))}
    ${cropFrame('yuz-harita', 114, 150, 36, 36, [1024, 1024], [170, 210, 720], [[620, 395], [245, 370]])}
    ${at(156, 154, 40, `<p class="keys-label">${T.yanak.glowTitle.join(' ').replace(/\.$/, '')}</p>${T.p.hl.where.map((t, i) => `<p style="display:grid;grid-template-columns:6mm 1fr;align-items:baseline;margin-top:1.4mm"><span style="font:300 11pt/1 var(--f-wide);color:var(--berry)">${i + 1}</span><span class="small" style="color:var(--ink)">${t}</span></p>`).join('')}`)}
    ${folio(34, { ch: 4 })}`);

  page(35, {}, () => `
    ${fullImg('sc-bronz', '50% 40%')}
    ${at(16, 16, 84, `${ptype('bronzer')}${pname('bronzer', 's')}${lead('bronzer')}${body('bronzer')}${howTo()}${steps(T.p.bronzer.steps)}<div style="margin-top:3mm">${warn(T.p.bronzer.warn)}</div><div style="margin-top:2.6mm">${keys(T.p.bronzer.keys, 'on-white')}</div><div style="margin-top:2.4mm">${metaOne('bronzer')}</div>`, 'card glass', 'padding:5mm 5.5mm')}
    `);

  /* ===== 05 · BAKIŞ ===== */
  page(36, { cls: 'bg-blush2' }, () => chapterPage(5, [[pn('palette'), PAGE.palette], [pn('brow'), PAGE.brow], [pn('browset'), PAGE.browset]]));
  page(37, {}, () => chapterPhoto(5));

  page(38, {}, () => `${fullImg('sc-far', '50% 50%')}`);
  /* the palette's twelve pans, back row then front row, as the real palette (src/refs/palette.jpg, store far-paleti photos):
     seven pearl (sedef) and five foil-glitter (sim) shades, no matte (2026-10-20 review: «mat olan renk yok») */
  const PANS = [['#F2EEEA', 'sim'], ['#EDE3D5', 'sedef'], ['#E8C9C5', 'sedef'], ['#DDA6AE', 'sedef'], ['#A4506E', 'sim'], ['#B97A5C', 'sim'],
    ['#C9A5AF', 'sedef'], ['#9E7774', 'sedef'], ['#B48A8F', 'sim'], ['#B9B9BD', 'sim'], ['#2A2729', 'sedef'], ['#D9A487', 'sedef']];
  page(39, {}, () => `
    ${at(18, 16, 100, `${ptype('palette')}${pname('palette')}${lead('palette')}${body('palette')}`)}
    ${at(126, 18, 70, `<p class="keys-label">${T.bakis.mapTitle}</p>
      <div style="display:grid;grid-template-columns:repeat(6,1fr);gap:1.4mm;background:#231F20;padding:2mm;border-radius:2mm">${PANS.map(([c]) => `<span style="aspect-ratio:1;background:${c};border-radius:.6mm"></span>`).join('')}</div>
      <div style="display:grid;grid-template-columns:repeat(6,1fr);gap:1.4mm;padding:1mm 2mm 0" class="tiny">${PANS.map(([, f]) => `<span style="text-align:center">${T.p.palette.finishes[f]}</span>`).join('')}</div>`)}
    ${cropFrame('goz-bolge', 16, 78, 100, 58.3, [1264, 848], [100, 60, 1164], [[600, 400], [640, 310], [830, 425]])}
    ${at(124, 80, 72, `<p class="keys-label">${T.bakis.ideasTitle}</p>` + T.p.palette.zones.map(([z, d], i) => `<div style="display:grid;grid-template-columns:7mm 1fr;border-bottom:.25mm solid var(--line);padding:1.5mm 0"><span style="font:300 12pt/1 var(--f-wide);color:var(--berry)">${i + 1}</span><span><b style="font:600 8.6pt/1.2 var(--f-display)">${z}</b><br><span class="small">${d}</span></span></div>`).join(''))}
    ${at(18, 160, 178, `<div style="display:flex;gap:8mm;align-items:flex-start"><div style="flex:1">${warn(T.p.palette.warn)}</div><div>${metaOne('palette')}</div></div>`)}
    ${folio(39, { ch: 5 })}`);

  page(40, {}, () => `${fullImg('sc-kas', '50% 62%')}`);
  page(41, {}, () => `
    ${at(18, 16, 96, `${ptype('brow')}${pname('brow', 's')}${lead('brow')}${body('brow')}${howTo()}${steps(T.p.brow.steps)}`)}
    ${at(124, 18, 72, `<p class="keys-label">${T.bakis.tonesTitle}</p>` + P('brow').shades.map((s) => `<div style="display:grid;grid-template-columns:38mm 1fr;align-items:center;gap:2.4mm;border-bottom:.25mm solid var(--line);padding:1.8mm 0">
      <img src="${sw(s.key)}" style="width:38mm;height:12mm;object-fit:contain" alt=""><span><span class="shade-name" style="font-size:8.4pt">${s.name}</span><br><span class="shade-code">${s.sku}<br>${s.barcode}</span></span></div>`).join('') + `<p class="tiny" style="margin-top:2mm">${T.bakis.tonesNote}</p><p class="meta" style="margin-top:1.4mm">${T.meta.size} ${sizeOf('brow')}</p>`)}
    <div class="rule" style="left:18mm;top:118mm;width:178mm"></div>
    ${at(18, 126, 96, `${ptype('browset')}${pname('browset', 's')}${lead('browset')}${body('browset')}<div style="margin-top:2.4mm">${metaOne('browset')}</div>`)}
    ${at(124, 126, 72, `${title(T.bakis.twoTitle, 's')}<div style="margin-top:3mm">${T.bakis.two.map(([a, b], i) => `<span style="display:flex;justify-content:space-between;border-top:.25mm solid var(--line-strong);padding:1.6mm 0"><span class="small">${a}</span><b style="font:600 8.4pt/1.2 var(--f-display)">${b}</b></span>`).join('')}</div>`)}
    ${folio(41, { ch: 5 })}`);

  /* ===== 06 · DUDAK ===== */
  page(42, { cls: 'bg-blush2' }, () => chapterPage(6, [[pn('gl'), PAGE.gl], [pn('ml'), PAGE.ml], [pn('el'), PAGE.el]]));
  page(43, {}, () => chapterPhoto(6));

  /* caption under each dessert + tube pair: [centre x on the spread (mm), side] — the last one is set flush right */
  const VITRIN = { 'Brownie Bite': [30, 'l'], 'Spiced Cookie': [96, 'l'], 'Pink Donut': [261, 'r'], 'Cherry Pie': [337, 'r'], 'Candy Apple': [388, 'r', 'right'] };
  const vitrinCaps = (side) => P('gl').shades.filter((s) => VITRIN[s.name][1] === side).map((s) => {
    const [x, , align] = VITRIN[s.name]; const px = side === 'l' ? x : x - 210;
    const box = align === 'right' ? 'left:160mm;width:36mm;text-align:right' : `left:${px - 18}mm;width:36mm;text-align:center`;
    return `<div class="abs" style="${box};top:189mm"><p class="shade-name">${s.name}</p><p class="shade-code">${s.sku} · ${s.barcode}</p></div>`;
  }).join('');
  page(44, { spread: true }, () => `
    ${spreadImg('sc-vitrin', 'left', '50% 46%')}
    ${at(14, 14, 120, `${eyebrow(pn('gl'))}${title(T.dudak.vitrinTitle, 'm', 'margin-top:2.4mm')}`)}
    ${at(132, 46, 64, `${lead('gl', '')}${body('gl')}`, 'card glass', 'padding:3.5mm 4.5mm')}
    ${vitrinCaps('l')}`);
  page(45, { spread: true }, () => `
    ${spreadImg('sc-vitrin', 'right', '50% 46%')}
    ${at(14, 16, 54, `${howTo('')}${steps(T.p.gl.steps)}<p class="meta" style="margin-top:3mm">${T.meta.size} ${sizeOf('gl')}</p>`)}
    ${vitrinCaps('r')}
    `);

  page(46, {}, () => `${fullImg('sc-mat')}`);
  page(47, {}, () => {
    const sh = P('ml').shades;
    const pos = [[18, 98, -8], [80, 92, 6], [142, 100, -4], [46, 140, 5], [112, 142, -7]];
    return `
    ${at(18, 16, 100, `${ptype('ml')}${pname('ml')}${lead('ml')}${body('ml')}`)}
    ${at(128, 18, 68, `${howTo('')}${steps(T.p.ml.steps)}`)}
    ${sh.map((s, i) => { const [x, y, r] = pos[i]; return `<div class="abs" style="left:${x}mm;top:${y}mm;width:50mm;text-align:center">
        <img src="${swSrc('kiss', s.key)}" style="width:40mm;height:28mm;object-fit:contain;margin:0 auto;transform:rotate(${r}deg)" alt="">
        <p class="shade-name" style="margin-top:1.4mm">${s.name}</p><p class="shade-code">${s.sku} · ${s.barcode}</p></div>`; }).join('')}
    ${at(18, 186, 178, `<p class="tiny">${T.meta.size} ${sizeOf('ml')}</p>`)}
    ${folio(47, { ch: 6 })}`;
  });

  page(48, {}, () => `${fullImg('sc-easy', '50% 60%')}`);
  page(49, {}, () => {
    const cols = T.dudak.cmpCols, rows = T.dudak.cmpRows;
    return `
    ${at(18, 16, 100, `${ptype('el')}${pname('el')}${lead('el')}${body('el')}`)}
    ${at(126, 16, 70, P('el').shades.map((s) => shadeRow('el', s, { w: 22, h: 10, style: 'margin-bottom:2mm' })).join('') + `<p class="meta">${T.meta.size} ${sizeOf('el')}</p>`)}
    ${at(18, 96, 170, title(T.dudak.cmpTitle, 'm'))}
    <table class="cmp" style="left:18mm;top:120mm;width:178mm"><thead><tr><th></th>${cols.map((c, i) => `<th><img src="${[sw('gl-pink-donut'), sw('ml-vampire-kiss'), sw('el-rose'), sw('tint-mercan')][i]}" style="width:22mm;height:10mm;object-fit:contain;margin-bottom:1.4mm" alt="">${c}</th>`).join('')}</tr></thead>
      <tbody>${rows.map((r) => `<tr><th>${r[0]}</th>${r.slice(1).map((c) => `<td>${c}</td>`).join('')}</tr>`).join('')}
      <tr><th></th>${['gl', 'ml', 'el', 'tint'].map((k) => `<td>${pref(PAGE[k])}</td>`).join('')}</tr></tbody></table>
    ${folio(49, { ch: 6 })}`;
  });

  /* ===== 07 · SON DOKUNUŞ ===== */
  page(50, { cls: 'bg-blush2' }, () => chapterPage(7, [[pn('powder'), PAGE.powder], [pn('spray'), PAGE.spray], [T.p.bag.short, PAGE.bag]]));
  page(51, {}, () => chapterPhoto(7));

  /* 52 — SETTING POWDER, right before the spray (moved from p25 on 2026-10-20): the two jars as packshots beside the text.
     The texture atlas that stood on p53 went in the same review («sayfanın mantığını anlamadım») */
  page(52, {}, () => `
    ${at(18, 16, 96, `${ptype('powder')}${pname('powder')}${lead('powder')}${body('powder')}`)}
    ${at(18, 60, 96, P('powder').shades.map((s) => shadeRow('powder', s, { w: 22, h: 14, style: 'margin-bottom:2mm' })).join(''))}
    ${at(18, 98, 96, `${howTo()}${steps(T.p.powder.steps)}<div style="margin-top:3mm">${warn(T.p.powder.warn)}</div><p class="meta" style="margin-top:2.4mm">${T.meta.size} ${sizeOf('powder')}</p>`)}
    <img class="pack" src="${packSrc('powder-trans')}" style="left:124mm;top:24mm;width:70mm" alt="">
    ${at(124, 72, 70, `<p class="shade-name" style="text-align:center">${P('powder').shades[0].name}</p>`)}
    <img class="pack" src="${packSrc('powder-pink')}" style="left:124mm;top:92mm;width:70mm" alt="">
    ${at(124, 140, 70, `<p class="shade-name" style="text-align:center">${P('powder').shades[1].name}</p>`)}
    ${folio(52, { ch: 7 })}`);

  page(53, {}, () => `
    ${at(18, 16, 98, `${ptype('spray')}${pname('spray')}${lead('spray')}${body('spray')}${howTo()}${steps(T.p.spray.steps)}<div style="margin-top:3.4mm">${metaOne('spray')}</div>`)}
    <img class="pack" src="${packSrc('spray')}" style="left:124mm;top:14mm;width:72mm;height:176mm" alt="">
    ${folio(53, { ch: 7 })}`);

  page(54, {}, () => `${fullImg('sc-canta', '50% 34%')}`);
  page(55, {}, () => `
    ${at(18, 16, 104, `${ptype('bag')}${pname('bag')}${lead('bag')}<p class="small" style="margin-top:2mm">${T.p.bag.care}</p><div style="margin-top:2.6mm">${metaOne('bag')}</div>`)}
    ${at(18, 96, 86, title(T.canta.checkTitle, 'm'))}
    ${at(18, 120, 90, `<p class="body">${T.canta.checkIntro}</p>`)}
    ${at(112, 96, 84, T.canta.check.map(([k, n]) => `<span class="shortcut"><span>${n}</span><i></i><b>${PAGE[k]}</b></span>`).join(''))}
    <img class="pack" src="${packSrc('bag')}" style="left:138mm;top:12mm;width:58mm" alt="">
    ${folio(55, { ch: 7 })}`);

  /* ===== LOOKS ===== */
  const lookCard = (L, x, y, w) => at(x, y, w, `
      <p class="title m" lang="en">${L.name}</p>
      <p class="keys-label" style="margin:1mm 0 2.4mm">${L.line}</p>
      ${L.items.map(([k, v]) => `<span style="display:grid;grid-template-columns:1fr auto;gap:2mm;border-bottom:.25mm solid var(--line);padding:1.05mm 0;font-size:6.9pt"><span><b style="font-weight:600">${T.p[k].short || T.p[k].name}</b>${v ? ` · ${v}` : ''}</span><b style="color:var(--berry)">${PAGE[k]}</b></span>`).join('')}`);
  page(56, {}, () => {
    const [a, b] = T.looks.list;
    return `
    ${at(14, 14, 120, `${eyebrow(T.looks.eyebrow)}${title(T.looks.title, 'm', 'margin-top:2mm')}`)}
    ${at(14, 41, 96, `<p class="small">${T.looks.intro}</p>`)}
    ${frame('look-pink-donut', 14, 56, 58, 76, 'arch', '50% 28%')}
    ${lookCard(a, 80, 58, 52)}
    ${frame('look-honey-beige', 138, 92, 58, 76, 'arch', '50% 28%')}
    ${lookCard(b, 14, 142, 112)}
    ${folio(56)}`;
  });
  page(57, {}, () => {
    const [, , c, d] = T.looks.list;
    return `
    ${frame('look-coral-sunset', 18, 16, 58, 76, 'arch', '50% 28%')}
    ${lookCard(c, 84, 18, 56)}
    ${frame('look-vampire-kiss', 138, 100, 58, 76, 'arch', '50% 28%')}
    ${lookCard(d, 18, 110, 108)}
    ${folio(57)}`;
  });

  /* ===== GUIDES ===== */
  page(58, {}, () => {
    const L = T.needs.list, half = Math.ceil(L.length / 2);
    /* an answer can name several products ('caps-aa caps-e caps-c caps-ret': all four capsule serums, 2026-10-20 review); such a
       cell may wrap */
    const row = ([q, k]) => {
      const ks = k.split(' ');
      return `<span class="need"><span class="q">${q}</span><span class="a${ks.length > 1 ? ' many' : ''}">${ks.map((x) => `<span>${T.p[x].short || T.p[x].name}</span>`).join(' · ')}<b>${PAGE[ks[0]]}</b></span></span>`;
    };
    return `
    ${at(14, 16, 120, eyebrow(T.needs.eyebrow))}
    ${at(14, 24, 182, title(T.needs.title, 'l', 'white-space:nowrap'))}
    ${at(14, 44, 120, `<p class="note" style="color:var(--ink)">${T.needs.intro}</p>`)}
    ${at(14, 60, 88, L.slice(0, half).map(row).join(''))}
    ${at(108, 60, 88, L.slice(half).map(row).join(''))}
    ${folio(58)}`;
  });
  page(59, { cls: 'bg-blush' }, () => `
    ${at(18, 16, 120, eyebrow(T.moments.eyebrow))}
    ${at(18, 24, 170, title(T.moments.title, 'l'))}
    ${T.moments.list.map((m, i) => at(18 + (i % 2) * 92, 70 + Math.floor(i / 2) * 42, 86, `
      <h4><span>${m.t[0]}</span> <i>${m.t[1]}</i></h4>
      <ul>${m.items.map((k) => `<li><span style="display:contents"><span>${T.p[k].short || T.p[k].name}</span><b>${PAGE[k]}</b></span></li>`).join('')}</ul>`, 'moment')).join('')}
    ${folio(59)}`);

  page(60, {}, () => {
    const L = T.faq.list;
    const col = (list) => list.map(([q, a]) => `<div class="qa"><h4>${q}</h4><p>${a}</p></div>`).join('');
    return `
    ${at(14, 16, 120, eyebrow(T.faq.eyebrow))}
    ${at(14, 24, 170, title(T.faq.title, 'l'))}
    ${at(14, 66, 86, col(L.slice(0, 6)))}
    ${at(108, 66, 88, col(L.slice(6)))}
    <img class="abs" src="${brand('qr-rosecandy.svg')}" style="left:108mm;top:174mm;width:18mm;height:18mm" alt="">
    ${at(130, 177, 66, `<p class="small"><b>${T.back.url}</b><br>${T.back.qr}</p>`)}
    ${folio(60)}`;
  });

  /* 61 — the brand and the company, nothing else (2026-10-20 review: «sadece marka, firma bilgilerinin yer aldığı kısım kalsın»),
     centred on the page; the book's one AI line stays under it (Alp, 2026-10-19: one small line at the back) */
  page(61, {}, () => {
    const C = T.colophon;
    return `
    <div class="abs" style="left:18mm;top:76mm;width:174mm;text-align:center">
      <img src="${brand('logo-t.svg')}" style="width:52mm;margin:0 auto" alt="Rose Candy">
      <p class="small" style="margin-top:8mm"><b>${C.company}</b><br>${C.address}<br>${C.phone}<br>${C.mail}<br>${C.social}</p>
      <p class="tiny" style="margin-top:9mm;color:var(--ink-2)">${C.ai}</p></div>
    ${folio(61)}`;
  });

  /* index: every product, every shade */
  const ORDER = ['micellar', 'foam', 'caps-aa', 'caps-e', 'caps-c', 'caps-ret', 'spf', 'primer', 'fdn', 'conc', 'sponge', 'puff', 'lb', 'cb', 'tint', 'hl', 'bronzer',
    'palette', 'brow', 'browset', 'gl', 'ml', 'el', 'powder', 'spray', 'bag'];
  const idxRows = (keys) => {
    const out = [];
    keys.forEach((k) => {
      const p = P(k); const vs = p.shades || [{ name: '—', sku: p.sku, barcode: p.barcode, hex: null }];
      vs.forEach((s, i) => out.push(`<tr class="${i === 0 ? 'first' : ''}"><td class="pn">${i === 0 ? T.p[k].name : ''}</td>
        <td>${s.hex ? `<span class="dot" style="background:${s.hex}"></span>` : ''}${s.name}</td><td>${s.sku}</td><td>${s.barcode}</td><td>${i === 0 ? sizeOf(k) || '—' : ''}</td>
        <td class="pg">${i === 0 ? `<span>${PAGE[k]}</span>` : ''}</td></tr>`));
    });
    return out;
  };
  const idxTable = (rows, top) => `<table class="idx" style="left:14mm;top:${top}mm"><colgroup><col style="width:52mm"><col style="width:38mm"><col style="width:17mm"><col style="width:30mm"><col style="width:33mm"><col style="width:14mm"></colgroup>
    <thead><tr>${T.index.cols.map((c) => `<th>${c}</th>`).join('')}</tr></thead><tbody>${rows.join('')}</tbody></table>`;
  const IDX_BREAK = ORDER.indexOf('tint');                         // page 62 ends with the cream blush
  page(62, {}, () => `${at(14, 14, 120, eyebrow(T.index.eyebrow))}${at(14, 21, 180, `<p class="p-name">${T.index.title}</p>`)}${idxTable(idxRows(ORDER.slice(0, IDX_BREAK)), 34)}${folio(62)}`);
  page(63, {}, () => `${idxTable(idxRows(ORDER.slice(IDX_BREAK)), 16)}${folio(63)}`);

  /* 64 — BACK COVER: a still life of the lip glosses, the logo and the slogan on its calm top, the way to the shop below */
  const BACK = { img: 'arka-kapak', pos: '50% 50%' };         // agy scene «arka-kapak»: the glosses in the lower half, calm pink above
  page(64, { cls: 'pg-cover' }, () => `
    ${fullImg(BACK.img, BACK.pos)}
    <img class="cover-logo" src="${brand('logo-white-t.svg')}" style="top:20mm;width:96mm" alt="Rose Candy">
    <p class="back-slogan" style="top:52mm">${T.back.slogan}</p>
    <div class="back-shop"><img class="qr" src="${brand('qr-rosecandy.svg')}" alt=""><p><b>${T.back.url}</b><span>${T.back.qr}<br>${T.back.social}</span></p></div>
    <p class="back-company">${T.back.company}</p>`);

  /* ---------- build ---------- */
  RC.buildPages = function (lang) {
    T = RC.content[lang];
    const sorted = PG.slice().sort((a, b) => a.n - b.n);
    return sorted.map((p) => `<section class="page ${p.cls || ''}" data-n="${p.n}" lang="${T.meta.lang}">${p.render()}</section>`);
  };
  RC.pageCount = () => PG.length;
})();
